import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrReadinessApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    readinessDashboard(owningCompanyId?: number, assignmentType?: string, readinessStatus?: string): Observable<APIResponseWrapper<HrModels.HrWorkforceReadinessDashboard>> {
        return this.http.get<APIResponseWrapper<HrModels.HrWorkforceReadinessDashboard>>(`${this.baseUrl}/workforce/readiness/dashboard`, {
          params: this.params({ owningCompanyId, assignmentType, readinessStatus })
        });
      }
    
    evaluateReadiness(request: HrModels.HrWorkforceReadinessEvaluationRequest = {}): Observable<APIResponseWrapper<HrModels.HrWorkforceReadinessEvaluationResult>> {
        return this.http.post<APIResponseWrapper<HrModels.HrWorkforceReadinessEvaluationResult>>(`${this.baseUrl}/workforce/readiness/evaluate`, request);
      }
    
    readinessSnapshots(owningCompanyId?: number, assignmentType?: string, readinessStatus?: string): Observable<APIResponseWrapper<HrModels.HrWorkforceReadinessSnapshot[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrWorkforceReadinessSnapshot[]>>(`${this.baseUrl}/workforce/readiness/snapshots`, {
          params: this.params({ owningCompanyId, assignmentType, readinessStatus })
        });
      }
    
    readinessRules(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrWorkforceReadinessRule[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrWorkforceReadinessRule[]>>(`${this.baseUrl}/workforce/readiness/rules`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveReadinessRule(request: HrModels.HrWorkforceReadinessRule): Observable<APIResponseWrapper<HrModels.HrWorkforceReadinessRule>> {
        return request.readinessRuleId
          ? this.http.put<APIResponseWrapper<HrModels.HrWorkforceReadinessRule>>(`${this.baseUrl}/workforce/readiness/rules/${request.readinessRuleId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrWorkforceReadinessRule>>(`${this.baseUrl}/workforce/readiness/rules`, request);
      }
    
    readinessOverrides(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrReadinessOverride[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrReadinessOverride[]>>(`${this.baseUrl}/workforce/readiness/overrides`, {
          params: this.params({ owningCompanyId })
        });
      }
    
    saveReadinessOverride(request: HrModels.HrReadinessOverride): Observable<APIResponseWrapper<HrModels.HrReadinessOverride>> {
        return this.http.post<APIResponseWrapper<HrModels.HrReadinessOverride>>(`${this.baseUrl}/workforce/readiness/overrides`, request);
      }
    
    revokeReadinessOverride(overrideId: number, reason?: string, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrReadinessOverride>> {
        return this.http.post<APIResponseWrapper<HrModels.HrReadinessOverride>>(`${this.baseUrl}/workforce/readiness/overrides/${overrideId}/revoke`, { reason }, {
          params: this.params({ owningCompanyId })
        });
      }
    
    driverQualifications(owningCompanyId?: number, employeeId?: number): Observable<APIResponseWrapper<HrModels.HrDriverQualification[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrDriverQualification[]>>(`${this.baseUrl}/workforce/driver-qualifications`, {
          params: this.params({ owningCompanyId, employeeId })
        });
      }
    
    saveDriverQualification(request: HrModels.HrDriverQualification): Observable<APIResponseWrapper<HrModels.HrDriverQualification>> {
        return request.driverQualificationId
          ? this.http.put<APIResponseWrapper<HrModels.HrDriverQualification>>(`${this.baseUrl}/workforce/driver-qualifications/${request.driverQualificationId}`, request)
          : this.http.post<APIResponseWrapper<HrModels.HrDriverQualification>>(`${this.baseUrl}/workforce/driver-qualifications`, request);
      }
  };
}

